import PropTypes from "prop-types";

import "../../../styles/StudentAutoSuggest.scss";
import "../../../styles/ActionButton.scss";

/**
 * Build the auto complete list
 * @name OptionList
 * @param {string} className
 * @param {[]} filteredOptions
 * @param {{}} formState
 * @param {func} handleChooseStudent
 * @param {func} resetAutoSuggest
 * @param {bool} showOptions
 * @component
 */
const OptionList = ({ className, filteredOptions, formState, handleChooseStudent, resetAutoSuggest, showOptions }) => {
    if (showOptions && formState?.studentSearch?.length > 2) {
        if (filteredOptions?.length) {
            return (
                <div className="auto-suggest-contain">
                    <div className={className}>
                        <ul className="option-list-ul">
                            <li className="border-bottom">
                                <div
                                    style={{ fontSize: "1.2em" }}
                                    type="button"
                                    onClick={() => {
                                        resetAutoSuggest();
                                    }}
                                >
                                    <div className="option-close-button">
                                        <i className="bi-x-lg"></i>
                                    </div>
                                </div>
                            </li>
                            {filteredOptions.map((dto, index) => {
                                const uniqueKey = `autoSuggest-${index}`;
                                return (
                                    <li key={uniqueKey}>
                                        <button
                                            className="btn"
                                            onClick={() => handleChooseStudent(index)}
                                            onKeyDown={() => handleChooseStudent(index)}
                                            type="button"
                                        >
                                            <div className="option-result-container">
                                                <div className="single">{`${dto.lastName}, ${dto.firstName}`}</div>
                                                <div className="single">{`#: ${dto.studentNumber}`}</div>
                                            </div>
                                        </button>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                </div>
            );
        }
        return (
            <div className="auto-suggest-contain">
                <div className={className}>
                    <ul className="option-list-ul">
                        <li className="border-bottom">
                            <div
                                style={{ fontSize: "1.2em" }}
                                type="button"
                                onClick={() => {
                                    resetAutoSuggest();
                                }}
                            >
                                <div className="option-close-button">
                                    <i className="bi-x-lg"></i>
                                </div>
                            </div>
                        </li>
                        <div style={{ padding: "20px" }}>
                            No matching student found. Please try again with a valid student name or student number.
                        </div>
                    </ul>
                </div>
            </div>
        );
    }

    return null;
};

OptionList.propTypes = {
    className: PropTypes.string,
    filteredOptions: PropTypes.instanceOf(Array),
    formState: PropTypes.oneOfType([PropTypes.object]).isRequired,
    handleChooseStudent: PropTypes.func.isRequired,
    resetAutoSuggest: PropTypes.func.isRequired,
    showOptions: PropTypes.bool
};

OptionList.defaultProps = {
    className: "auto-suggest",
    filteredOptions: [],
    setSearchFlag: null,
    showOptions: false,
    showResetButton: false
};

export default OptionList;
